module.exports = __webpack_public_path__ + "img/trialPicture.f665e233.png";